import React, { useState } from "react";
import "./Switch.css";
const Switch = ({
  onText = '',
  offText = '',
  isOn,
  keyCode,
  onToggle,
  width,
  height,
  borderRadius,
  fontSize
}) => {
  // const [isOn, setIsOn] = useState(initialState);

  const handleToggle = () => {
    const newState = !isOn;
    if (!!onToggle) {
      onToggle(keyCode, newState); // Call callback if provided
    }
  };

  return (
    <div
      className="toggle-btn-container"
      onClick={handleToggle}
      style={{
        backgroundColor: isOn ? '#38b1aa' : '#ccc',
        cursor: 'pointer',
        width: width || 'fit-content',
        height: height || '25px',
        borderRadius: borderRadius || '14px',
      }}
    >
      <div
        className="toggle-btn-wrapper"
        style={{ order: isOn ? 1 : 0, marginLeft: isOn ? '0' : '4px', marginRight: isOn ? '4px' : 0 }}
      >
        <div className="toggle-btn" />
      </div>
      {
        isOn ?
          <div className="toggle-btn-text-container" style={{ fontSize: fontSize || '14px' }}>
            <div className="toggle-btn-text">
              {onText}
            </div>
          </div> :
          <div className="toggle-btn-text-container" style={{ fontSize: fontSize || '14px' }}>
            <div className="toggle-btn-text">
              {offText}
            </div>
          </div>
      }
    </div >
  );
};

export default Switch;
